<script lang="ts">
    import { createEventDispatcher, onMount } from "svelte"
    import { mdiClose } from "@mdi/js"
    import Icon from "./Icon.svelte"
    import Notifications from "./Notifications.svelte"

    export let showCloseIcon: boolean = true
    export let show: boolean = false
    export let size: string = "md"
    export let cssClass: string = ""
    export let closeOnBackdrop: boolean = false

    let dialog: HTMLDialogElement
    let dispatch = createEventDispatcher()

    const onCancel = () => {
        show = false
        dialog.close()
        dispatch("close")
    }

    const onDialogClick = (e: Event) => {
        if (closeOnBackdrop && (e.target as HTMLElement).nodeName === "DIALOG") {
            dialog.close()
            show = false
            dispatch("close")
        }
    }

    $: if (dialog) {
        if (show) {
            dialog.showModal()
            document.body.classList.add("no-overflow")
            dialog.classList.add("dialog-open")
        } else if (dialog.classList.contains("dialog-open")) {
            document.body.classList.remove("no-overflow")
            dialog.classList.remove("dialog-open")
            dialog.close()
            dispatch("close")
        }
    }
    onMount(() => {
        return () => {
            dialog.classList.remove("dialog-open")
            document.body.classList.remove("no-overflow")
        }
    })
    //
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<dialog
    class="modal {size ? 'modal-' + size : ''} {cssClass}"
    bind:this="{dialog}"
    on:cancel="{onCancel}"
    on:click|stopPropagation="{onDialogClick}"
    on:keypress
    data-cy="modal"
>
    {#if $$slots.close || showCloseIcon}
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="modal-close"
            on:click|stopPropagation="{() => {
                dispatch('close')
            }}"
            on:keydown
        >
            {#if showCloseIcon}
                <Icon path="{mdiClose}" size="24px" />
            {/if}
            <slot name="close" />
        </div>
    {/if}
    {#if $$slots.header}
        <div class="modal-header">
            <slot name="header" />
        </div>
    {/if}
    {#if $$slots.default}
        <div class="modal-content">
            <slot />
        </div>
    {/if}
    {#if $$slots.footer}
        <div class="modal-footer">
            <slot name="footer" />
        </div>
    {/if}
    <Notifications force="{true}" />
</dialog>
